import clsx from "clsx";
import { FC } from "react";

import { showPageDisabled } from "components/materials/page/groups/helpers";
import { PageType } from "components/server-types";
import { ClassCollaborationIcon, PersonGroupIcon, PersonSingleIcon } from "mds/icons";
import { isGroupPage, isIndividualPage, isSharedClassPage, isStaticPage } from "utils/page-utils";

// This is only designed to be used by PageListItem
export const IconFromPage: FC<{ page: PageType; isSelected?: boolean }> = ({
  page,
  isSelected,
}) => {
  const isDisabled = showPageDisabled(page);
  const circleClassName = "flex h-6 w-6 flex-none items-center justify-center rounded-full";

  const getBgColorClass = (bgColorClass: string) => {
    if (isSelected) {
      return "";
    }

    return isDisabled ? "bg-black-tint-97" : bgColorClass;
  };

  const getIconColorClass = (iconColorClass: string) => {
    if (isSelected) {
      return "text-white";
    }

    return isDisabled ? "text-black-tint-55" : iconColorClass;
  };

  if (isStaticPage(page)) {
    return null;
  }

  if (isIndividualPage(page)) {
    return (
      <div className={clsx(circleClassName, getBgColorClass("bg-blue-tint-93"))}>
        <PersonSingleIcon className={getIconColorClass("text-blue")} size="xs" />
      </div>
    );
  }

  if (isGroupPage(page)) {
    return (
      <div className={clsx(circleClassName, getBgColorClass("bg-hibiscus-tint-95"))}>
        <PersonGroupIcon className={getIconColorClass("text-hibiscus")} size="xs" />
      </div>
    );
  }

  if (isSharedClassPage(page)) {
    return (
      <div className={clsx(circleClassName, getBgColorClass("bg-moss-tint-95"))}>
        <ClassCollaborationIcon className={getIconColorClass("text-moss")} size="xs" />
      </div>
    );
  }

  return null;
};
